import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dict from 'api/data-dict';
import localStorage from 'helpers/local-storage';
import { InputListBox } from 'containers/form';
import { getCurrencyFromQuery } from 'components/view-map-search';


export default class CurrenciesChanger extends Component {
  static propTypes = {
    changeCurrency: PropTypes.func,
    queryCurrency: PropTypes.shape({}),
    currency: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);
    let selectedCurrency = localStorage.get('searchByCurrency') || props.currency;
    if (props.queryCurrency) selectedCurrency = getCurrencyFromQuery(props.queryCurrency) || selectedCurrency;

    this.state = { selectedCurrency: selectedCurrency || 'uah' };
  }

  componentDidUpdate(prevProps) {
    if (this.props.queryCurrency) {
      const selectedCurrency = getCurrencyFromQuery(this.props.queryCurrency) || this.props.currency;
      if (this.state.selectedCurrency !== selectedCurrency)
        this.setState({ selectedCurrency: selectedCurrency || 'uah' });
    }
  }

  changeCurrency = (val) => {
    const { changeCurrency } = this.props;
    const { selectedCurrency } = this.state;

    if (selectedCurrency !== val) {
      localStorage.emit('searchByCurrency', val);
      this.setState({ selectedCurrency: val });
      if (changeCurrency) changeCurrency(val);
    }
  }

  render() {
    const { selectedCurrency } = this.state;

    return (
      <Dict url="currencies-changer" injectPropName="listBoxItems">
        <InputListBox
          dictValue="name_short"
          value={selectedCurrency}
          onChange={this.changeCurrency}
          nullValueItem={false}
        />
      </Dict>
    );
  }
}
